import { AuditCheckboxColumn, AuditCheckboxSettings } from "./types"

export const AUDIT_CHECKBOX_COLUMNS: AuditCheckboxColumn[] = ["readyForCheck", "readyForApproval", "approved"]

type AuditCheckboxValues = Record<AuditCheckboxColumn, 0 | 1>
type AuditCheckboxEnabledValues = Partial<Record<`${AuditCheckboxColumn}Enabled`, boolean>>

export const makeAuditCheckboxSettings = ({
  isMemberContext,
  readyForCheck,
  readyForApproval,
  approved,
  readyForCheckEnabled = isMemberContext,
  readyForApprovalEnabled = isMemberContext,
  approvedEnabled = isMemberContext,
}: {
  isMemberContext: boolean
} & AuditCheckboxValues &
  AuditCheckboxEnabledValues): AuditCheckboxSettings => {
  if (isMemberContext) {
    const readyForCheckCanEdit = readyForCheckEnabled ? 1 : 0
    const readyForApprovalCanEdit = readyForApprovalEnabled ? 1 : 0
    const approvedCanEdit = approvedEnabled ? 1 : 0

    return {
      readyForCheckCanEdit,
      readyForCheckCanFocus: readyForCheckCanEdit,
      readyForCheckType: "Bool",
      readyForCheck,
      readyForApprovalCanEdit,
      readyForApprovalCanFocus: readyForApprovalCanEdit,
      readyForApprovalType: "Bool",
      readyForApproval,
      approvedCanEdit,
      approvedCanFocus: approvedCanEdit,
      approvedType: "Bool",
      approved,
    }
  }

  return {
    readyForCheckCanEdit: 0,
    readyForCheckCanFocus: 0,
    readyForCheckType: "Html",
    readyForCheck: "",
    readyForApprovalCanEdit: 0,
    readyForApprovalCanFocus: 0,
    readyForApprovalType: "Html",
    readyForApproval: "",
    approvedCanEdit: 0,
    approvedCanFocus: 0,
    approvedType: "Html",
    approved: "",
  }
}
